<script>
import { mapActions, mapState } from "vuex";

export default {
  props: {
    // Id of the modal, for v-b-modal.the-id
    modalId: {
      type: String,
      default: "delete-group-modal",
    },

    // The group ID possibly being deleted
    groupId: {
      type: String,
      required: true,
    },
  },

  computed: {
    // The group to delete
    group() {
      return this.groups[this.groupId];
    },

    // Mapped vuex state
    ...mapState(["groups"]),
  },

  methods: {
    // Delete the group, hide the modal, and go to the groups page
    async doDelete() {
      await this.deleteGroup({ groupId: this.groupId });
      this.hide();
      this.$router.push("/groups");
    },

    // Hide the modal
    hide() {
      this.$refs.modal.hide();
    },

    // Mapped vuex actions
    ...mapActions(["deleteGroup"]),
  },
};
</script>

<template>
  <b-modal
    ref="modal"
    :id="modalId"
    title="Confirm Delete"
    button-size="sm"
    hide-header-close
  >
    <p v-if="group">
      Are you sure you want to delete
      <b>{{ group.name }}</b>
      ? Doing so will also delete all its historical data.
    </p>
    <p>
      Workers within this group will
      <b>not</b>
      be deleted.
    </p>
    <template #modal-footer>
      <div class="float-right">
        <b-button class="mr-3" variant="light" @click="hide">Cancel</b-button>
        <b-button variant="danger" @click="doDelete">Delete</b-button>
      </div>
    </template>
  </b-modal>
</template>

<style scoped></style>
